export class Login {
}

export class LoginModel {
    email: string = '';
    password: string = '';
    deviceToken:string;
    platformTypeId: number = 1;
    rememberMe :boolean = false;
    trustToken:string
}

export class ForgetPasswordModel {
    email: string;
}

export class VerifyOtpModel {
    email: string = '';
    otp: string
}

export class ResetPasswordModel{
    resetPasswordToken: string;
    email: string;
    newPassword: string;

}

export class ChangePasswordModel{
    currentPassword: string;
    newPassword: string;
    isSmsAllowed: boolean;
    phoneCodeId?: number;
    contactNumber?: string;
}

export class Verification{
    email: string;
    otpToken: string;
    twoFactorToken: boolean;
}

export enum View{
    Login = 1,
    ForgotPasswordWithEmail = 2,
    CreateNewPassword = 3,
    Verification = 4
}

export enum PlatformType {
    Web = 1,
    Android = 2,
    iOS = 3
}